var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25834"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25584"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25583"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 1",
    d: "M4.5 0 9 7H0z",
    transform: "rotate(180 7 8.5)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 2",
    d: "M4.5 0 9 7H0z",
    transform: "translate(5 1)",
    style: {
      fill: "#eee"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.133e2238cbb5131b7e176f2f1cce6b95.svg";
export { ForwardRef as ReactComponent };